export default __webpack_public_path__ + "static/tech2heal-d047ca9767915d763ffe81d6e0e1217a.png";